const stats = [
  { number: '300+', label: 'Lives Impacted', icon: 'ri-heart-line' },
  { number: '9', label: 'Core Programs', icon: 'ri-book-open-line' },
  { number: '1+', label: 'Years of Service', icon: 'ri-calendar-check-line' },
  { number: '10+', label: 'Community Partners', icon: 'ri-shake-hands-line' },
];

export default function StatsSection() {
  return (
    <section className="bg-[#ADD8E6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-[#003366]/10 rounded-full">
                <i className={`${stat.icon} text-2xl text-[#003366]`} />
              </div>
              <p className="text-4xl font-bold text-[#003366] mb-1">{stat.number}</p>
              <p className="text-[#003366]/70 text-sm font-medium uppercase tracking-wide">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
